import { render } from "./hr-card.vue?vue&type=template&id=068973bf&scoped=true"
import script from "./hr-card.vue?vue&type=script&lang=js"
export * from "./hr-card.vue?vue&type=script&lang=js"

import "./hr-card.vue?vue&type=style&index=0&id=068973bf&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068973bf"]])

export default __exports__